import {Center} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import {AvatarShape, AvatarSize} from './AvatarConstants';

interface AvatarBenchlingIconProps {
  icon: BenchlingIconName;
  backgroundColor: string;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
  size: AvatarSize;
  shape?: AvatarShape;
}

/**
 * An icon over a circle with a background color, for parties with no image or initials, such as agents.
 */
export default function AvatarBenchlingIcon({
  icon,
  backgroundColor,
  className,
  dataTestAttrs,
  size,
  shape = AvatarShape.CIRCLE,
}: AvatarBenchlingIconProps): JSX.Element {
  return (
    <span
      className={classNames(`avatar avatar--text avatar--${size} avatar--${shape}`, className)}
      style={{backgroundColor}}
      {...getTestProps(dataTestAttrs)}
    >
      <Center component="span" h="100%">
        <BenchlingIcon icon={icon} />
      </Center>
    </span>
  );
}
